
        import 'Spinner.d1fa161.css-module'
        export default {"Modal":"Modal_Spinner_d1fa161","Spinner":"Spinner_Spinner_d1fa161","Dot":"Dot_Spinner_d1fa161","pulse":"pulse_Spinner_d1fa161"}
    